var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAccelerationScore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.8614 18.4023C25.8614 18.4023 25.0665 19.38 25.5068 20.3897C25.7012 20.8331 25.9757 21.1269 26.2216 21.41C26.5362 21.7733 27.6399 22.7349 25.4382 24.8771C24.0771 26.202 22.27 27.8741 22.27 27.8741C22.27 27.8741 20.6973 26.3302 20.1426 25.8441C18.6615 24.5459 18.7472 22.9005 19.8681 21.207",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7624 10.8555C17.7624 10.8555 16.7158 11.5981 15.635 11.1868C15.1603 11.0051 14.8458 10.7487 14.5427 10.519C14.1539 10.2252 13.1245 9.19411 10.8313 11.2509C9.41301 12.5223 7.62305 14.2105 7.62305 14.2105C7.62305 14.2105 9.27576 15.6796 9.79617 16.1978C11.1858 17.5814 12.9472 17.5013 14.76 16.4542",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0854 26.1181C14.0854 26.1181 16.3329 23.7888 14.0282 21.8817C11.7751 20.0226 8.85278 21.6573 8.71553 23.8476C8.70981 23.9331 8.78415 24.0025 8.87565 24.0025H9.90503C9.9279 24.0025 9.94506 24.0292 9.9279 24.0453C9.48184 24.5154 8.6755 25.1084 8.69265 26.8019C8.69265 26.8766 8.77271 26.9354 8.85278 26.9354H9.85356",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.6958 26.8242C12.6958 26.8242 11.8781 27.0271 11.1689 26.883",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0284 21.8802C15.4295 24.781 11.6609 24.4231 11.4321 24.4498C11.4321 24.4498 11.1691 20.2775 14.0284 21.8802Z",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4395 17.4148L18.9058 21.6298C25.8712 19.8295 33.7631 13.7714 33.7116 3.46094C23.8983 3.66394 15.9721 10.4165 14.4395 17.4148Z",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1796 7.61175C32.7164 7.93228 29.4453 5.4428 29.2451 3.98438",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5102 14.5282C25.9031 14.5282 27.0322 13.4735 27.0322 12.1723C27.0322 10.8712 25.9031 9.81641 24.5102 9.81641C23.1174 9.81641 21.9883 10.8712 21.9883 12.1723C21.9883 13.4735 23.1174 14.5282 24.5102 14.5282Z",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.298 20.2609L16.606 23.2312C16.5946 23.2846 16.5259 23.3006 16.4859 23.2632L12.6029 19.6519C12.5628 19.6145 12.58 19.5504 12.6372 19.5397L15.9541 18.8398",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.38335 17.3516L6.1416 19.4394",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.44886 20.166L3.60742 21.8801",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.94081 17.7246L4.32812 19.2785",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.29507 15.4824L4.91113 16.7693",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.12239 17.5098L3.70996 17.8889",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.33009 16.459L6.69531 17.057",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.98 29.0977L18.7383 31.1855",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0475 31.9121L16.2061 33.6262",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5394 29.4707L16.9268 31.0246",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8947 27.2266L17.5107 28.5135",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.722 29.2598L16.3096 29.6389",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9297 28.207L19.2949 28.8051",
    stroke: "#791508",
    strokeWidth: 1.2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAccelerationScore);
export default __webpack_public_path__ + "static/media/ic_acceleration_score.68595f7d7b1c1d38ea2c44693a3852cd.svg";
export { ForwardRef as ReactComponent };